import React from "react";
import TooltipEx from "@components/Tooltip";
import classNames from "classnames";
import styles from "../../dashboardWF/wf.dashboard.module.css";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import {StatoRichiesta} from "@commons/mapping/Workflow";
import {PageType} from "../../dashboardWF/wf.dashboard.detail";
import {DashboardWFRootDetails} from "@commons/mapping/dashboard.types";
import {IconBan, IconCheck, IconHourglass, IconScale, IconTrash} from "@tabler/icons-react";

export const ContatoriRichiesteWF: React.FC<{
    causaliWF?: PresenzeCausaleWFRecord[],
    contatoriDetails?: DashboardWFRootDetails,
    page: PageType,
    contatoriClassName?: string
}> = ({
          causaliWF = [],
          contatoriDetails,
          page,
          contatoriClassName = ''
      }) => {

    const filterRichiesteValide = (richiesta: PresenzeCausaleWFRecord, stato: StatoRichiesta) => {
        return richiesta.wf.stato === stato && !richiesta.wf.annullata;
    }

    const getInAttesa = () => {
        let inAttesa = causaliWF.filter((richiesta) => filterRichiesteValide(richiesta, 'IN_ATTESA'))
        return inAttesa.length ? inAttesa.length : 0
    }

    const getInValutazione = () => {
        let inValutazione = causaliWF.filter((richiesta) => filterRichiesteValide(richiesta, 'IN_VALUTAZIONE'))
        return inValutazione.length ? inValutazione.length : 0
    }

    const getAccettate = () => {
        let accettate = causaliWF.filter((richiesta) => filterRichiesteValide(richiesta, 'ACCETTATA'))
        return accettate.length ? accettate.length : 0
    }

    const getRespinte = () => {
        let respinte = causaliWF.filter((richiesta) => filterRichiesteValide(richiesta, 'RIFIUTATA'))
        return respinte.length ? respinte.length : 0
    }

    const getAnnullate = () => {
        let annullate = causaliWF.filter((richiesta) => richiesta.wf.annullata)
        return annullate.length ? annullate.length : 0
    }

    return (<div className={`${styles.contatoriWF} ${contatoriClassName}`}>
            <TooltipEx tooltip={`Richieste in attesa di valutazione`}>
                <div className={classNames(styles.stateContainer, styles.inAttesaBkColor)}>
                    <IconHourglass size={16}/>
                    {page !== 'monitorWF' && <>{causaliWF.length > 0 ? getInAttesa() : 0}</>}
                    {page === 'monitorWF' && <>{contatoriDetails && contatoriDetails.count0 || 0}</>}
                </div>
            </TooltipEx>
            <TooltipEx tooltip={`Richieste in valutazione`}>
                <div className={classNames(styles.stateContainer, styles.inValutazioneBkColor)}>
                    <IconScale size={16}/>
                    {page !== 'monitorWF' && <>{causaliWF.length > 0 ? getInValutazione() : 0}</>}
                    {page === 'monitorWF' && <>{contatoriDetails && contatoriDetails.count1 || 0}</>}
                </div>
            </TooltipEx>
            <TooltipEx tooltip={`Richieste accettate`}>
                <div className={classNames(styles.stateContainer, styles.accettataBkColor)}>
                    <IconCheck className="h-4 w-4"/>
                    {page !== 'monitorWF' && <>{causaliWF.length > 0 ? getAccettate() : 0}</>}
                    {page === 'monitorWF' && <>{contatoriDetails && contatoriDetails.count2 || 0}</>}
                </div>
            </TooltipEx>
            <TooltipEx tooltip={`Richieste respinte`}>
                <div className={classNames(styles.stateContainer, styles.respintaBkColor)}>
                    <IconBan size={16}/>
                    {page !== 'monitorWF' && <>{causaliWF.length > 0 ? getRespinte() : 0}</>}
                    {page === 'monitorWF' && <>{contatoriDetails && contatoriDetails.count3 || 0}</>}
                </div>
            </TooltipEx>
            <TooltipEx tooltip={`Richieste annullate`}>
                <div className={classNames(styles.stateContainer, styles.annullataBkColor)}>
                    <IconTrash className="h-4 w-4"/>
                    {page !== 'monitorWF' && <>{causaliWF.length > 0 ? getAnnullate() : 0}</>}
                    {page === 'monitorWF' && <>{contatoriDetails && contatoriDetails.countAnnullate || 0}</>}
                </div>
            </TooltipEx>
        </div>
    )
};
